import { characters } from "@/mocks/narutoData";
import SectionHeading from "./SectionHeading";

export default function CharacterSection() {
  return (
    <section id="character" className="scroll-mt-20 bg-background-100/60 py-16 md:py-24">
      <div className="mx-auto max-w-[1200px] px-4 md:px-6">
        <SectionHeading
          eyebrow="角色合集"
          title="按角色整理的同人作品专题"
          desc="每个忍者都有说不完的故事。围绕主要角色的同人作品专题，一网打尽他们的千百种人生。"
        />

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {characters.map((c) => (
            <article
              key={c.id}
              className="group relative overflow-hidden rounded-lg border border-background-200 bg-background-50"
            >
              <div className="relative h-52 w-full overflow-hidden">
                <img
                  src={c.cover}
                  alt={`${c.name}火影忍者同人角色合集专题`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-50 via-background-50/20 to-transparent" />
                <div className="absolute bottom-3 left-4 right-4 flex items-end justify-between">
                  <div>
                    <h3 className="font-heading text-xl font-bold text-foreground-950">{c.name}</h3>
                    <p className="text-xs text-primary-500">{c.epithet}</p>
                  </div>
                  <span className="rounded-full bg-primary-500 px-2.5 py-1 text-xs font-medium text-background-50 whitespace-nowrap">
                    {c.count} 篇同人
                  </span>
                </div>
              </div>
              <div className="p-4 pt-2">
                <p className="text-sm leading-relaxed text-foreground-600">{c.desc}</p>
                <button className="mt-3 inline-flex items-center gap-1 text-sm font-medium text-primary-500 transition-colors hover:text-primary-400">
                  查看合集 <i className="ri-arrow-right-line" />
                </button>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}